// extracted by mini-css-extract-plugin
export default {"cont":"EditProfile_cont__dTK8K","mnForm":"EditProfile_mnForm__m-UDP"};